import * as R from 'ramda';
import { isNilOrEmpty } from '../../language/module';
import { GuestDetails } from '../guestDetails';


/**
 * Predicate for whether or not the given guest (or undefined) has downloaded photo data.
 */
export const hasPhoto = (
  guest: GuestDetails | undefined,
): boolean => !isNilOrEmpty(R.path([ 'photo', 'imgSmall' ], guest))
              || !isNilOrEmpty(R.path([ 'photo', 'imgLarge' ], guest));


/**
 * The guest's downloaded photo data (small preferred, large as a fallback), or undefined when none has been
 * downloaded. This is the photo the guest card shows, and it is replaced as soon as a new photo is uploaded.
 */
export const getPhotoData = (
  guest: GuestDetails | undefined,
): string | undefined => guest?.photo?.imgSmall || guest?.photo?.imgLarge || undefined;
